import { render, staticRenderFns } from "./AgendaMain.vue?vue&type=template&id=5a8566c5"
import script from "./AgendaMain.vue?vue&type=script&lang=js"
export * from "./AgendaMain.vue?vue&type=script&lang=js"
import style0 from "./AgendaMain.vue?vue&type=style&index=0&id=5a8566c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports